import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["button", "hiddenInput"]

    connect() {
        this.setActiveButton(this.hiddenInputTarget.value);
    }

    selectCase(event) {
        const selectedCase = event.currentTarget.dataset.case;

        this.setActiveButton(selectedCase);
        this.hiddenInputTarget.value = selectedCase;
    }

    setActiveButton(caseValue) {
        this.buttonTargets.forEach(button => {
            if (button.dataset.case === caseValue) {
                button.classList.add("active");
            } else {
                button.classList.remove("active");
            }
        });
    }

    reset() {
        const defaultCase = "uppercase";
        this.setActiveButton(defaultCase);
        this.hiddenInputTarget.value = defaultCase;
    }
}